import mixpanel from 'mixpanel-browser';
import config from '../../../../config';
var MixpanelTracker = /** @class */ (function () {
    function MixpanelTracker() {
        try {
            var isLocal = !config.deploymentEnv;
            this.disabled = !config.analytics.Mixpanel.token;
            if (!this.disabled) {
                mixpanel.init(config.analytics.Mixpanel.token, {
                    debug: isLocal,
                    verbose: isLocal,
                    autocapture: true,
                });
            }
        }
        catch (e) {
            console.error('Error initializing Mixpanel', e);
        }
    }
    MixpanelTracker.prototype.shouldTrack = function () {
        return !this.disabled;
    };
    MixpanelTracker.prototype.identify = function (userId, username) {
        try {
            if (this.shouldTrack()) {
                mixpanel.identify(userId);
                mixpanel.people.set({ username: username });
            }
        }
        catch (e) {
            console.error('Error identifying user in Mixpanel', e);
        }
    };
    MixpanelTracker.getInstance = function () {
        if (MixpanelTracker.instance === null) {
            MixpanelTracker.instance = new MixpanelTracker();
        }
        return MixpanelTracker.instance;
    };
    MixpanelTracker.init = function () {
        MixpanelTracker.getInstance();
    };
    return MixpanelTracker;
}());
export { MixpanelTracker };
MixpanelTracker.instance = null;
